export enum UliEndpoint {
  Active = '/active',
  Addresses = '/addresses',
  Allocation = '/allocation',
  Assign = '/assign',
  Base = '/monitoring/uli',
  Carriers = '/carriers',
  Compartments = '/compartments',
  CreateAndAllocate = '/create-allocate',
  Details = '/details',
  Filters = '/filters',
  Hubs = '/hubs',
  Information = '/information',
  LoadExist = '/load-exists',
  MultiStop = '/multi-stop',
  Overview = '/overview',
  ParkingSpot = '/parking-spot',
  Preview = '/preview',
  SapNotify = '/sap/notify',
  Send = '/send',
  Statuses = '/statuses',
  Truck = '/truck',
  Trucks = '/trucks',
  Uli = '/uli',
  Update = '/update',
  WebUli = '/web-uli',
  V2 = '/v2',
}
